<ag1-dropdown-button
  [disabled]="isLoading || isEmpty"
  [items]="fileFormats"
  (clickEvent)="download($event)"
  variant="tertiary"
  [isLoading]="isGenerating"
  [label]="isGenerating ? 'Generating File' : 'Download'"
/>
